<template>
<div v-if="!isSearchUser" id="main">
    <header>
        いいね
        <div class="h-left">
            <a @click="refresh"><img src="~@/assets/images/icon04.svg" /></a>
        </div>
    </header>
    <div id="wrap3">
        <header class="menu">
        <ul class="h-menu clearfix" v-if="parseInt(type) === 1">
            <li>相手から</li>
            <a @click="setType(2)">
                <li>スキップ</li>
            </a>
            <a @click="setType(0)">
                <li>自分から</li>
            </a>
        </ul>
        <ul class="h-menu clearfix" v-if="parseInt(type) === 2">
            <a @click="setType(1)">
                <li>相手から</li>
            </a>
            <li>スキップ</li>
            <a @click="setType(0)">
                <li>自分から</li>
            </a>
        </ul>
        <ul class="h-menu clearfix" v-if="parseInt(type) === 0">
            <a @click="setType(1)">
                <li>相手から</li>
            </a>
            <a @click="setType(2)">
                <li>スキップ</li>
            </a>
            <li>自分から</li>
        </ul>
        </header>
        <div v-for="(date, index) in dateTL" :key="index">
            <p style='font-size: 12px; padding: 2%;'>{{ date }}&nbsp;</p>
            <div class="list"  v-for="(item, i) in arrayDate[date]" :key="i">
                <div class="clearfix">
                    <div class="list-img" @click="openDetail(item.id)">
                        <a><img  :src="getImageUrl(item.avatar_url)" /></a>
                    </div>
                    <div class="list-inf">
                        <table>
                            <tr @click="openDetail(item.id)">
                                <td>
                                    <p>
                                        <span class="list-name" style="display: flex">
                                            <!-- <span v-if="item.is_new">
                                                <span class="red b">NEW&nbsp;</span>
                                            </span> -->
                                            {{ getLiving(item.living_area) }} 
                                            <span style="margin: 0 4px" class="ellipsis">{{ item.display_name }}</span> 
                                            {{ item.age }}歳
                                        </span>
                                    </p>
                                </td>
                                <td width="64" style="text-align: end; position: relative;">
                                    <span v-if="parseInt(item.online) == IS_ONLINE">
                                        <span style="height: 10px; width: 10px" class="p-login"></span>
                                        <span style="font-size: 10px;">オンライン</span>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td v-if="parseInt(item.sex) === FEMALE">
                                    {{getFieldProfile('height', item.height)}}
                                    {{ getFieldProfile('job', item.job) }}
                                </td>
                                <td v-else>
                                    <span class="pink"> {{ getFieldProfile('income', item.income) }}</span>
                                </td>
                                <td rowspan="2" style="text-align: end;">
                                    {{item.time_at}}
                                </td>
                            </tr>
                            <tr>
                                <td class="ellipsis">
                                    {{ item.mood_status_tmp }}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <div style="display: flex; align-items: center">
                                        <div style="flex: 1" v-if="type === 0">
                                            <div class="iine-btn2" v-if="item.message != ''"><a>メッセージ付きいいね！済み</a></div>
                                            <div :id="'iine_'+i+'_'+index" :class="parseInt(item.look_at_me_status) !== IS_LOOK_AT_ME ? 'iine-btn1': 'iine-btn2'" @click="lookAtMe(item.id, i, index)" v-else-if="parseInt(item.look_at_me_status) !== IS_LOOK_AT_ME"><a>みてねする</a></div>
                                            <div class="iine-btn2" v-else><a>みてね！済み</a></div>
                                        </div>
                                        <div style="flex: 1" v-if="type === 1">
                                            <div class="grid-2">
                                                <div class="iine-btn1" @click="likeUser(item.id, date, i)"><a>マッチングする</a></div>
                                                <div class="iine-btn2" @click="skip(item.id, i, date)">スキップ</div>
                                            </div>
                                        </div>
                                        <div style="flex: 1" v-if="type === 2">
                                            <div class="iine-btn1" @click="likeUser(item.id, date, i)"><a>マッチングする</a></div>
                                        </div>

                                        <div style="display: flex; flex-direction: column; margin-left: 6px; min-width: 63px" @click="openDetail(item.id)">
                                            <span class="pink icon" v-if="parseInt(item.enabled_call) === IS_CALL">
                                                <i class="fas fa-phone"></i> 通話OK&nbsp;
                                            </span>
                                            <span class="pink2 icon" v-if="parseInt(item.waiting_for_meet) === IS_WAITING_FOR_MEET">
                                                <i class="fas fa-calendar-check"></i> 本日OK
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div v-if="item.message && item.message != ''">
                        <h4>メッセージ</h4>
                        <p style="background: #D7D3D3;">{{ item.message }}</p>
                    </div>
                </div>
            </div>
        </div>
        <infinite-loading @infinite="getLikes" spinner="spiral" :identifier="infiniteId">
            <template v-slot:no-more></template>
            <template v-slot:no-results>
                <div id="middle" style="width: 70%;">
                    <div v-if="type === 1">
                        <p class="iine01">まだお相手からの<br />いいね！はありません。</p>
                        <p>プロフィールを充実されるといいね！がつきやすくなります。</p>
                        <div class="btn1"><a @click="$router.push({ name: 'editProfile' })">プロフィールを編集</a></div>
                    </div>
                    <div v-if="type === 2">スキップしたお相手はいません</div>
                    <div v-if="type === 0">
                        <p class="iine01">自分からの<br/>いいね！はありません。</p>
                        <p>たくさんのいいね！をすると<br/>マッチング率が上がります。</p>
                        <div class="btn1"><a @click="openSearchForm">会員を検索する</a></div>
                    </div>
                </div>
            </template>
        </infinite-loading>

    </div>
</div>
<div v-else>
    <!-- <div id="search">
        <search @close="saveDataSearch" :dataSearch="dataSearch" @openDetail="openDetail" />
    </div> -->
    <div id="search" class="hidden-right">
        <search  @close="saveDataSearch" :dataSearch="dataSearch" />
    </div>
</div>
<div id="detail" class="hidden-detail">
    <detail v-if="isShowDetail" :idUser="userId" @close="closeDetail"></detail>
</div>
<div class="loading-screen" v-if="isLoading">
    <div class="loader"></div>
</div>
</template>

<script>
import CONSTANTS from "@/constants";
import mixin from "@/mixin";
import search from "../user/components/search"
import detail from "../user/detail"
import {
    mapActions,
    mapGetters
} from "vuex";
export default {
    mixins: [mixin],
    components: {
        search,
        detail
    },
    data: () => ({
        type: 1,
        pageSize: CONSTANTS.DEFAULT_PAGE_SIZE,
        pageCurrent: 1,
        likeList: [],
        IS_LIKE: CONSTANTS.IS_LIKE,
        IS_CALL: CONSTANTS.IS_CALL,
        IS_WAITING_FOR_MEET: CONSTANTS.IS_WAITING_FOR_MEET,
        FEMALE: CONSTANTS.FEMALE,
        IS_LOOK_AT_ME: CONSTANTS.IS_LOOK_AT_ME,
        IS_ONLINE: CONSTANTS.IS_ONLINE,
        infiniteId: +new Date(),
        arrayDate: [],
        dateTL: [],
        isSearchUser: false,
        dataSearch: null,
        formData: null,
        isShowDetail: false,
        userId: null,
        isLoading: true,
        scrollPosition: 0,
    }),
    mounted() {
        this.setFooter(true)
        if (this.$route.query.type) {
            this.type = this.$route.query.type
        }
    },
    computed: {
        ...mapGetters(["metadata", "defaultToken"]),
    
    },
    watch:{
        isShowDetail(val) {
            const body = document.getElementsByTagName('body')[0];
            if (val) body.style.overflow = "hidden";
            else body.style.overflow = "auto";
        }
    },
    methods: {
        ...mapActions({
            setFooter: 'layout/setFooter',
        }),
        openDetail(id) {
            this.setScrollPosition()
            this.setFooter(false)
            if (this.isSearchUser) {
                document.getElementById('search').style.display = "none"
                // this.isSearchUser = true
            } else {
                document.getElementById('main').style.display = "none"
            }
            document.getElementById('detail').classList.add('show-detail')
            document.getElementById('detail').classList.remove('hidden-detail')
            this.isShowDetail = true
            this.userId = id
        },
        closeDetail() {
            this.scrollToPosition()
            this.setFooter(true)
            document.getElementById('detail').classList.remove('show-detail')
            document.getElementById('detail').classList.add('hidden-detail')
            if (this.isSearchUser) {
                document.getElementById('search').style.display = "unset"
            } else {
                document.getElementById('main').style.display = "unset"
            }
            this.isShowDetail = false
        },
        saveDataSearch(data) {
            this.isSearchUser = false
            this.dataSearch = data
        },
        openSearchForm() {
            this.isSearchUser = true
            this.setFooter(false)
        },

        async setType(type) {
            this.isLoading = true
            this.likeList = []
            this.arrayDate = []
            this.dateTL = []
            this.type = type
            this.pageCurrent = 1
            this.infiniteId++

            // Scroll to Top
            window.scrollTo(0, 0)
        },
        async refresh() {
            this.isLoading = true
            this.infiniteId++
            this.likeList = []
            this.arrayDate = []
            this.dateTL = []
            this.pageCurrent = 1
        },
        async getLikes($state = null) {
            if (this.likeList.length > 0 && this.likeList.length <  this.pageSize && $state) {
                $state.complete()
                return
            }
            // console.log('call 1')
            let params = {
                token: this.defaultToken,
                page: this.pageCurrent,
                limit: this.pageSize,
                type: this.type
            }
            // console.log('call 2', params)
            await this.$store.dispatch('like/getLikes', params).then(data => {
                if (data.length > 0) {
                    this.pageCurrent++
                    // console.log('call 3', this.pageCurrent, data)
                    this.likeList.push(...data)

                    this.likeList = this.likeList.sort((a, b) => {
                        if (new Date(a.send_date_time) > new Date(b.send_date_time)) return -1;
                        if (new Date(a.send_date_time) < new Date(b.send_date_time)) return 1;
                        return 0;
                    });
                    this.dateTL = this.likeList.map(item => {
                        return this.formatDateTime(item.send_date_time);
                    })
                    this.dateTL = Array.from(new Set(this.dateTL))
                    for (let i = 0; i < this.dateTL.length; i++) {

                        let arr = this.likeList.filter(e => {
                            return this.formatDateTime(e.send_date_time) == this.dateTL[i]
                        })
                        if (arr.length > 0) {
                            this.arrayDate[this.dateTL[i]] = arr
                        }
                    }
                    if ($state) {
                        $state.loaded()
                    }
                } else {
                    if ($state) {
                        $state.complete()
                    }
                }
            }).catch(err => {
                if ($state) {
                    $state.complete()
                }
            })
            this.isLoading = false
        },
        getLiving(id) {
            if (!this.metadata.user_profile_list) return;
            let living = this.metadata.user_profile_list.living_area.filter(
                (item) => {
                    return item.value === id;
                }
            );
            if (living[0]) {
                return living[0].name;
            }
            return null;
        },
        lookAtMe(id, i, index) {

            let formData = new FormData()
            formData.append('token', this.defaultToken)
            formData.append('user_look_at_id', id)
            formData.append('message', CONSTANTS.MESSAGE_LOOK_AT_ME)
            this.$store.dispatch('like/lookAtMe', formData).then((data) => {
                let btn = document.getElementById('iine_' + i + '_' + index)
                btn.html = '<a>みてね！済み</a>'
                btn.className = 'iine-btn2'
            }).catch(err => {
                console.log(err)
            })
        },
        skip(id, index, date) {
            let formData = new FormData();
            formData.append("type", 2);
            formData.append("token", this.defaultToken);
            formData.append("user_like_id", id);
            this.$store
                .dispatch("user/likeUser", formData)
                .then(() => {
                    this.refresh()
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async likeUser(id, date, i) {
            let formData = new FormData();
            formData.append("type", 0);
            formData.append("token", this.defaultToken);
            formData.append("user_like_id", id);

            await this.$store
                .dispatch("user/likeUser", formData)
                .then(() => {
                    this.arrayDate[date].splice(i, 1)
                    if (this.arrayDate.length === 1 && this.arrayDate[date].length === 1) {
                        this.dateTL = []
                    }
                    // this.refresh()
                })
                .catch((err) => {
                    // console.log('Lỗi:',  err);
                });
        },
        getFieldProfile(field, id) {
            if (!this.metadata) return null
            let filedData = this.metadata.user_profile_list[field].filter((item) => {
                return parseInt(item.value) === parseInt(id);
            });
            if (filedData[0]) {
                return filedData[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        setScrollPosition() {
            this.scrollPosition = window.scrollY;
        },
        scrollToPosition() {
            setTimeout(() => {
                window.scrollTo(0, this.scrollPosition)
            }, 10);
        },
    },
};
</script>
<style scoped>
 .grid-2 {
     grid-gap: 5px;
     grid-template-columns: 2fr 1fr;
 }
 .iine-btn2, .iine-btn1 {
     font-size: 10px;
 }
 .hidden-detail {
  height: 0px;
  width: 0px;
  transform: scale(0, 0);
  overflow: hidden;
}
.show-detail {
  transform: scale(1, 1);
  height: 100%;
  width: 100%;
  overflow: unset;
}
#detail {
  transition: all 0.2s;
  top: 0;
  position: fixed;
}
.h-menu {
    position: unset;
}
#wrap3 {
    max-width: unset;
}
.menu {
    top: 42px;
}
.iine-btn1 a, .iine-btn2 a {
    font-size: 11px;
    padding: 8px;
    line-height: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
.iine-btn1, .iine-btn2 {
    line-height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.pink {
    font-size: 11px;
}

.pink.icon,
.pink2.icon {
    font-size: 10px;
}
</style>